<template>
  <div class="row mb-5">
<div class="col-xl-8 order-xl-1">
<client-details-card v-if="clientData != null" :client-data="clientData"></client-details-card>
      <card shadow type="secondary" class="mt-3">
        <template #header>
          <div class="bg-white border-0">
            <div class="row align-items-center">
              <div class="col-8 text-start">
                <h5 class="mb-0">{{ $t("Client Address") }}</h5>
              </div>
            </div>
          </div>
        </template>
        <client-address :client-data="clientData"></client-address>
      </card>
      <br />

      <card v-if="userRole === 'SYSTEM_USER'" shadow type="secondary" class="mt-3">
        <template #header>
          <div class="bg-white border-0">
            <div class="row align-items-center">
              <div class="col-8 text-start">
                <h5 class="mb-0">{{ $t("Blocked partners") }}</h5>
              </div>
            </div>
          </div>
        </template>

          <div class="pl-lg-4 text-start table-responsive">
            <table class="table align-items-center table-flush text-start">
              <thead>
              <tr>
                <th>{{ $t("Name") }}</th>
                <th>{{ $t("Partner status") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="employee in employees" :key="employee.id">
                <td>
                  <router-link :to="`/employees/${employee.id}`">
                    <span class="name mb-0 text-sm fw-bolder">{{ employee.firstName }} {{ employee.lastName }} </span>
                  </router-link>
                </td>
                <td>
                  <div class="badge p-1 font-size-xs float-start" :class="getStatusClass(employee.status)">
                    <span class="status">{{ $t(employee.status ?? "") }}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
</card>
</div>
    <div v-if="canViewStatistics" class="col-xl-4 order-xl-1">
      <client-requests-analytics-card v-if="clientData != null" :client-data="clientData"></client-requests-analytics-card>
      <br />
    </div>
  </div>
</template>

<script>
import ClientDetailsCard from "@/views/Cards/ClientDetailsCard"
import ClientRequestsAnalyticsCard from "@/views/Cards/ClientRequestsAnalyticsCard"
import ClientAddress from "@/views/Cards/ClientAddressCard"
import {getStatusClass} from "@/helpers/common"

export default {
  name: "clientGeneral",
  components: {ClientAddress, ClientRequestsAnalyticsCard, ClientDetailsCard},
  props:{
    clientData: {
      type: Object
    }
  },
  data() {
    return {
      employees: [],
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user.claims.role ?? null
    },
    canViewStatistics() {
      return this.$store.getters.canViewStatistics
    },
  },
  mounted() {
    // console.log("clientData general", this.clientData)
    // get blocked employees
    this.getEmployees()
  },
  methods: {
    getStatusClass,
    async getEmployees() {
      await this.$store.dispatch("fetchEmployees", {limit: 20, blockedClientId: this.$route.params.id }).then((data) => {
        console.log("fetchBlockedEmployees", data)
        this.employees = data.data
      })
    },
  }
}
</script>

<style scoped>

</style>